(function () {
  const RUNTIME_KEY = 'PawlishCartDrawerExtrasRuntime';
  const previousRuntime = window[RUNTIME_KEY];

  if (previousRuntime && typeof previousRuntime.destroy === 'function') {
    previousRuntime.destroy();
  }

  const controller = typeof AbortController === 'function' ? new AbortController() : null;
  const fallbackCleanup = [];
  let cartUpdateUnsubscriber = null;
  let initTimer = null;

  function formatTimer(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  function readCountdownEndTime(storageKey) {
    try {
      return parseInt(sessionStorage.getItem(storageKey) || '0', 10);
    } catch (error) {
      return 0;
    }
  }

  function writeCountdownEndTime(storageKey, endTime) {
    try {
      sessionStorage.setItem(storageKey, String(endTime));
    } catch (error) {
      // Storage can be unavailable in restricted browsing contexts. The timer still works for this render.
    }
  }

  function initProCountdown(root) {
    root.querySelectorAll('[data-pro-countdown]').forEach((element) => {
      if (element.dataset.proCountdownInit === 'true') return;

      const totalSeconds = parseInt(element.dataset.seconds || '600', 10);
      const textTemplate = element.dataset.text || 'Cart reserved for [timer] more minutes!';
      const storageKey = `pro-cart-countdown-${totalSeconds}`;
      let endTime = readCountdownEndTime(storageKey);

      if (!endTime || endTime < Date.now()) {
        endTime = Date.now() + totalSeconds * 1000;
        writeCountdownEndTime(storageKey, endTime);
      }

      function tick() {
        if (!element.isConnected) return;

        const secondsLeft = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        element.textContent = textTemplate.replace('[timer]', formatTimer(secondsLeft));

        if (secondsLeft <= 0) {
          element.hidden = true;
          return;
        }

        window.setTimeout(tick, 1000);
      }

      element.dataset.proCountdownInit = 'true';
      tick();
    });
  }

  function initProDiscount(root) {
    root.querySelectorAll('[data-pro-discount]').forEach((wrapper) => {
      if (wrapper.dataset.proDiscountInit === 'true') return;

      const input = wrapper.querySelector('.pro-cart-discount__input');
      const button = wrapper.querySelector('.pro-cart-discount__button');
      const error = wrapper.querySelector('.pro-cart-discount__error');

      function applyDiscount() {
        const code = input ? input.value.trim() : '';

        if (!code) {
          if (error) error.hidden = false;
          return;
        }

        if (error) error.hidden = true;

        const routeRoot = window.Shopify?.routes?.root || '/';
        const normalizedRoot = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
        const checkoutPath = `${normalizedRoot}checkout`;
        window.location.href = `${normalizedRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(checkoutPath)}`;
      }

      if (button) button.addEventListener('click', applyDiscount);

      if (input) {
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          applyDiscount();
        });
      }

      wrapper.dataset.proDiscountInit = 'true';
    });
  }

  function init() {
    const root = document.getElementById('CartDrawer');
    if (!root) return;
    initProCountdown(root);
    initProDiscount(root);
  }

  function scheduleInit() {
    if (initTimer !== null) window.clearTimeout(initTimer);
    initTimer = window.setTimeout(() => {
      initTimer = null;
      init();
    }, 0);
  }

  function addDocumentListener(type, handler, options) {
    if (controller) {
      document.addEventListener(type, handler, Object.assign({}, options || {}, { signal: controller.signal }));
      return;
    }

    document.addEventListener(type, handler, options);
    fallbackCleanup.push(() => document.removeEventListener(type, handler, options));
  }

  addDocumentListener('shopify:section:load', scheduleInit);
  addDocumentListener('pro:cart:add:success', scheduleInit);

  function bindCartUpdate() {
    if (cartUpdateUnsubscriber) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;

    cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      scheduleInit();
    });
  }

  bindCartUpdate();

  if (document.readyState === 'loading') {
    addDocumentListener('DOMContentLoaded', () => {
      bindCartUpdate();
      init();
    }, { once: true });
  } else {
    init();
  }

  window[RUNTIME_KEY] = {
    version: '2.0.0',
    init,
    destroy() {
      if (controller) controller.abort();
      fallbackCleanup.splice(0).forEach((cleanup) => cleanup());
      if (typeof cartUpdateUnsubscriber === 'function') cartUpdateUnsubscriber();
      cartUpdateUnsubscriber = null;
      if (initTimer !== null) window.clearTimeout(initTimer);
      initTimer = null;
    },
  };
})();
